import { Alert } from '@mui/material'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useOutletContext, useParams } from 'react-router-dom'
import { Certificado, certificados } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirCertificado() {
    const { id } = useParams()
    const certificadosData = useOutletContext<Certificado[]>()
    const { mutateAsync, isLoading } = certificados.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!id) return null

    const isPrincipal =
        certificadosData.find(c => c.id === +id)?.tipo === 'principal'

    const handleSubmit = () => {
        mutateAsync(+id, {
            onSuccess: async () => {
                toast.success('Certificado excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            open={hasPermission(['delete', 'Certificados'])}
            onSubmit={handleSubmit}
            loading={isLoading}
            maxWidth="lg"
            height="auto"
        >
            <Dialog.Content>
                Deseja realmente excluir o certificado?
                {isPrincipal && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        Ao excluir o certificado principal, a empresa ficará sem
                        certificado da empresa.
                        <br />
                        Você pode substituir o certificado principal ao criar um
                        novo certificado enquanto o atual estiver expirado.
                    </Alert>
                )}
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
